// extracted by mini-css-extract-plugin
export default {"navbar":"Navigation_navbar__5KL9K","logoutBtn":"Navigation_logoutBtn__eKCbA","navRight":"Navigation_navRight__DNBrY","avatar":"Navigation_avatar__Qvarc"};